import React from 'react';
import { Modal } from 'react-bootstrap';
import { Download2Icon, ViewIcon, CloseIcon, Calendar } from 'assets/icons';
import { Constants, Globals } from 'utils';
import moment from 'moment';
import { Pagination, Input, DatePicker, Select, Button } from 'components';
import { ReportsService, GeneralService } from 'services';
import ModalPaymentRegister from './payment_register';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

const INITIAL_STATE = {
  search: '',
  type: '',
  speciality: '',
  status: '',
  from: null,
  to: null
}

const MODAL = {
  NONE: 0,
  REGISTER: 1,
  VIEW: 2,
};


const paymentStatus = [
  { value: Constants.STATUS_PAYMENT_MADE.PENDING, label: 'Pendiente' },
  { value: Constants.STATUS_PAYMENT_MADE.PAID, label: 'Pagado' }
]


const getStatusColor = (status: number) => {
  switch (status) {
    case Constants.STATUS_PAYMENT_MADE.PENDING:
      return { className: 'pending', label: 'Pendiente' };
    case Constants.STATUS_PAYMENT_MADE.PAID:
      return { className: 'paid', label: 'Pagado' };
    default:
  }
}

class PaymentsMade extends React.Component {

  debounce?: NodeJS.Timeout;

  state = {
    form: INITIAL_STATE,
    modal: MODAL.NONE,
    selectedItem: null,
    specialties: [],
    appointmenTypes: [],
    banks: [],
    status: [],
    data: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  componentDidMount(): void {
    this.getSelects()
    this.load()
  }

  load = async (page: number = 1, download: boolean = false) => {
    try {
      const { from, to } = this.state.form;
      const _from = from ? moment(from).format('YYYY-MM-DD') : '';
      const _to = to ? moment(to).format('YYYY-MM-DD') : '';

      const payload = { page, ...this.state.form, from: _from, to: _to, download };

      const res = await ReportsService.payemntsMade(payload)

      if (download) return res;

      const { data, ...rest } = res as any;
      this.setState({ data, pagination: rest });
    } catch (error) {
      const err = error as any;
      Globals.showError(err?.response?.data?.error ?? 'Ocurrió un error inesperado');
    }
  }


  download = async () => {
    try {
      const res: any = await this.load(this.state.pagination.page, true);
      if (!res?.url) return;

      const link = document.createElement('a');
      link.href = Globals.fromStorage(res?.url);
      link.download = 'reporte.xlsx';
      link.target = '_blank';
      link.click();

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  getSelects = async () => {
    const toSelect = (data: any) => data?.map((x: any) => ({ value: x.id, label: x.name })) ?? [];
    try {
      const specialities: any = await GeneralService.getSpecialties();
      const appointmentTypes: any = await GeneralService.getAppointmentTypes();
      const banks: any = await GeneralService.getBanks();
      this.setState({
        specialties: toSelect(specialities),
        appointmenTypes: toSelect(appointmentTypes),
        banks: toSelect(banks),
        status: paymentStatus,
      });
    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  change = async (value: string | number | boolean, target: keyof typeof INITIAL_STATE) => {
    const form = Globals.clone(this.state.form);
    form[target] = value;
    form['from'] = form.from ? new Date(form.from) : null;
    form['to'] = form.to ? new Date(form.to) : null;
    await this.setState({ form });

    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(async () => this.load(1), 800);
  }


  cleanFilters = async () => {
    await this.setState({ form: { ...INITIAL_STATE } });
    this.load(1);
  }

  setModal = async (modal: number, item?: any) => {
    this.setState({ modal, selectedItem: item ?? null });
  }



  render() {
    const { form, modal, specialties, status, appointmenTypes, banks, selectedItem } = this.state
    const canCleanFilters = JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);
    return (
      <div id="payments-made">
        <Modal
          id="payment-modal"
          size='sm'
          show={modal === MODAL.REGISTER}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalPaymentRegister
            item={selectedItem}
            banks={banks}
            onClose={(reload) => {
              if (reload) this.load()
              this.setModal(MODAL.NONE)
            }}
          />
        </Modal>

        <Modal
          id="payment-modal"
          size='sm'
          show={modal === MODAL.VIEW}
          onHide={() => this.setModal(MODAL.NONE)}
        >
          <ModalViewPaymentMade
            item={selectedItem}
            onClose={(reload) => {
              if (reload) this.load()
              this.setModal(MODAL.NONE)
            }}
          />
        </Modal>

        <section className="filters">
          <Input
            label="Buscar"
            placeholder="Nombre del médico"
            value={form.search}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search')}
          />

          <Select
            label="Especialidad"
            name="speciality"
            className="select-filter"
            value={form.speciality}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'speciality')}
            options={specialties}
          />

          <Select
            label="Modalidad"
            name="type"
            className="select-filter"
            value={form.type}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'type')}
            options={appointmenTypes}
          />

          <Select
            label="Estatus"
            name="status"
            className="select-filter"
            value={form.status}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'status')}
            options={status}
          />

          <DatePicker
            label="Desde"
            placeholder="Desde"
            maxDate={form.to || moment().toDate()}
            onChange={(v: string) => this.change(v, 'from')}
            value={form.from}
          />
          <DatePicker
            label="Hasta"
            placeholder="Hasta"
            maxDate={moment().toDate()}
            minDate={form.from}
            onChange={(v: string) => this.change(v, 'to')}
            value={form.to}
          />
          {canCleanFilters && (
            <Button clear onClick={this.cleanFilters}>
              Limpiar
            </Button>
          )}
        </section>

        <div className="rg-table">
          <div className="rg-table-header">
            <p></p>
            <div className="rg-table-actions">
              <button onClick={this.download}>
                <img src={Download2Icon} alt="Descargar" />
                <span>Descargar Excel</span>
              </button>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Fecha de la consulta</th>
                <th>Médico</th>
                <th>Especialidad</th>
                <th>Paciente</th>
                <th>Modalidad</th>
                <th>Pago al médico ($)</th>
                <th>Estatus</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((appointment: any, index: number) => {
                const status = appointment?.paymentMade === null ? Constants.STATUS_PAYMENT_MADE.PENDING : Constants.STATUS_PAYMENT_MADE.PAID;
                const color = getStatusColor(status);
                return (
                  <tr key={`patient-${index}`}>
                    <td>{moment(appointment?.date).format('DD-MM-YYYY')}</td>
                    <td>{appointment?.doctor?.full_name}</td>
                    <td>{appointment?.doctor?.specialty?.name}</td>
                    <td>{appointment?.user?.full_name}</td>
                    <td>{appointment?.type?.name}</td>
                    <td className='bold price'>{Globals.formatMiles(appointment?.service?.doctor_price)}</td>
                    <td className={color?.className}>{color?.label}</td>
                    <td className='flex-end'>
                      {
                        appointment?.paymentMade !== null
                          ? <img
                            src={ViewIcon}
                            alt="Descargar"
                            title="Descargar"
                            className='view-icon'
                            onClick={() => this.setModal(MODAL.VIEW, appointment)}
                          />
                          : <Button
                            className="register-btn"
                            onClick={() => this.setModal(MODAL.REGISTER, appointment)}
                          >
                            <span>Registrar pago</span>
                          </Button>
                      }


                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {!this.state.data.length && (
            <div className='no-items'>
              <p>No se encontraron resultados</p>
            </div>
          )}
        </div>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.load}
        />
      </div>
    )
  }
}

interface ModalViewPaymentMadeProps {
  onClose: (reload?: boolean) => void,
  item: any
}


const ModalViewPaymentMade = ({ onClose, item }: ModalViewPaymentMadeProps) => {

  return (
    <div>
      <header>
        <p className="title">Registrar pago</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className='details-section'>
        <div className='details'>
          <p>Banco</p>
          <span>{item?.paymentMade?.bank?.code} - {item?.paymentMade?.bank?.name}</span>
        </div>

        <div className='details'>
          <p>Fecha</p>
          <span>
            <img src={Calendar} alt="Fecha" />
            {moment(item?.paymentMade?.date).format('DD-MM-YYYY')}
          </span>
        </div>

        <div className='details'>
          <p>Numero de referencia</p>
          <span>{item?.paymentMade?.reference}</span>
        </div>

      </section>
    </div>
  )
}

export default PaymentsMade;